const SearchInput = ({ id, placeholder, value, setValue }) => {
    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <div className="search-wrapper">
            <input id={id} className="search" type="text" placeholder={placeholder} value={value} onChange={handleChange}  />
            <i className="fas fa-search" aria-hidden="true"></i>
        </div>
    );
}

export default SearchInput
